var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{ref:"img",style:({ margin: '0 auto', objectFit: _vm.index === 0 ? 'fill' : 'contain' })})
}
var staticRenderFns = []

export { render, staticRenderFns }